import React from 'react';

const ClockIcon = (): JSX.Element => {
	return <span className="fIcon icon-clock"></span>;
};

export default ClockIcon;
